import { CommandType } from "../../../../common/services/cqs/CommandType";
import { KontraktCommandBase } from "./KontraktCommandBase";

export class ConvertKontraktVersionCommand extends KontraktCommandBase {
    readonly viol3: boolean;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ConvertKontraktVersionCommand";

    constructor(viol3: boolean, kontraktGuid: string, avtalGuid: string) {
        super(avtalGuid, kontraktGuid, ConvertKontraktVersionCommand.$type, CommandType.Replace);
        this.viol3 = viol3;
    }
}
